// extracted by mini-css-extract-plugin
module.exports = {"WrapperDiv":"userprofilebox_WrapperDiv__39Xs0"};